export default __webpack_public_path__ + "static/media/Coinbase 1.005ca5f1.svg";